import React from 'react'

import { useDispatch } from '@hozana/redux/hooks'
import { useRouter } from '@hozana/router'
import { GTM_AUTH_SOURCE } from '@hozana/tracking/constants'
import { GTM } from '@hozana/tracking/gtm'

import { Button } from 'elements/button/Button'

import { openPopin } from 'general/actions'
import { POPINS } from 'general/managers/popins/constants'
import { PAGE } from 'routes/pages'

import { type TConnectPopinOptions } from 'modules/auth/popins/ConnectPopin'

export type TLostPwdSectionProps = { email: string; popinOptions?: TConnectPopinOptions & { noEscape?: boolean } }

export const LostPwdSection: TFC<TLostPwdSectionProps> = ({ email, popinOptions }) => {
  const dispatch = useDispatch()
  const { pathname } = useRouter()

  const openLostPwdPopin = () => {
    GTM.trackEvent(GTM.EVENTS.LOST_PASSWORD_OPENED)
    dispatch(
      openPopin(POPINS.LostPwdPopin, {
        ...popinOptions,
        authSource: pathname === PAGE.CONNECT ? undefined : GTM_AUTH_SOURCE.ALREADY_TRACKED,
        requestedEmail: email,
      }),
    )
  }

  return (
    <Button
      colors="greyTransparent"
      hoverColor="darkBlue"
      color="blue"
      onClick={openLostPwdPopin}
      bold={false}
      type="button"
      m="10px 0"
    >
      trans:auth:auth.recover.forgot-password
    </Button>
  )
}
